(function () {
    'use strict';

    angular.module('itxApp.home').service('homeRedirectSvc', homeRedirectSvc);

    homeRedirectSvc.$inject = ['homeManagerSvc', 'ItxApiSvc', 'HomeParseUrl', 'NavigationService'];

    function homeRedirectSvc(homeManagerSvc, ItxApiSvc, HomeParseUrl, NavigationService) {
        var _this = this;

        _this.pendingRedirect = false;
        _this.inditexLoaded = false;

        inditex.onReady(function () {
            _this.inditexLoaded = true;
            if (_this.pendingRedirect) {
                _redirectWithParams();
            }
        });

        return {
            checkIsRedirectUrl: _checkIsRedirectUrl,
            redirectForChina: redirectForChina,
            checkIfPendingRedirect: _checkIfPendingRedirect,
            redirectPending: redirectPending
        };

        function _checkIfPendingRedirect() {
            let cacheCategory = inditex.getLocalStorage('REDIRECT_CATEGORY');
            let cacheStaticUrl = inditex.getLocalStorage('REDIRECT_STATIC_URL');
            return cacheCategory || cacheStaticUrl;
           
        }
        function redirectPending(store, lang) {
            let cacheCategory = inditex.getLocalStorage('REDIRECT_CATEGORY');
            inditex.removeLocalStorage('REDIRECT_CATEGORY');
            let paramsRedirect = JSON.parse(cacheCategory);
            if (paramsRedirect && (paramsRedirect.categoryId || paramsRedirect.productId)) {
                // si tengo catalogId guardado navego a la categoria

                ItxApiSvc.getCategoryTree().then(function () {
                    if (paramsRedirect.productId) {
                        document.location.href = inditex.encodeUrl({
                            action: 'ItxProductPage',
                            params: {
                                storeId: store.id,
                                langId: lang.id,
                                categoryId: paramsRedirect.categoryId,
                                productId: paramsRedirect.productId
                            }
                        });
                    } else {
                        document.location.href = inditex.encodeUrl({
                            action: 'ItxCategoryPage',
                            params: {
                                storeId: store.id,
                                langId: lang.id,
                                categoryId: paramsRedirect.categoryId
                            }
                        });
                    }
                });
            } else {
                cacheCategory = inditex.getLocalStorage('REDIRECT_STATIC_URL');
                inditex.removeLocalStorage('REDIRECT_STATIC_URL');
                paramsRedirect = JSON.parse(cacheCategory);
                if (paramsRedirect && paramsRedirect.shareUrl) {
                    let pathRedirect = paramsRedirect.shareUrl.replace(window.location.origin+'/es/', '').split('/');
                    let url = inditex.encodeUrl({
                        action: 'ItxHomePage',
                        params: {
                            storeId: store.id,
                            langId: lang.id
                        }
                    }) + pathRedirect.join('/');
                    document.location.href = url;
                } else {
                    console.error('REDIRECTING INFORMATION WITH BAD INFO', paramsRedirect);
                }
            }
        }

        
        // Creamos esta funcion para generar la url con el store correcto
        // La api debería setearla en iParams.shareUrl pero lo genera erroneamente

        function _checkIsRedirectUrl() {
            
            var res = false;
            _this.iParams = inditex.decodeUrl(document.location).params;

            
            
            if (_this.iParams.redirect && _this.iParams.redirect.length && inditex.iPrevStoreId) {
                _this.typeRedirect = 'redirect';
                res = true;
            } else if (_this.iParams.shareUrl && _this.iParams.shareUrl.length > 0) {
                _this.typeRedirect = 'share';
                res = true;
            }

            
            if (res && _this.inditexLoaded) {
                _redirectWithParams();
            } else if (res && !_this.inditexLoaded) {
                _this.pendingRedirect = true;
            }

            return res;
        }

        /**
         * @ngdoc method
         * @name redirectForChina
         * @methodOf  home.service:homeManagerSvc
         * @description
         * China is blocking some urls from the domain massimodutti.com/cn to avoid problems
         * we do a redirect instead of resolving the logic by code
         * @param {string} storeId StoreId param
         * @param {number} langId language id
         * @param {string} section section selected
         * @returns {boolean} If true we will  then a document.location.redirect will be launch.
         *
         */

        function redirectForChina(storeId, langId, section) {
            if (storeId === 35009478) {
                
                var url;
               /* var storeFound = _.find(inditex.iStoreListJSON.stores, function (storeToFind) {
                    return storeToFind.id == 35009478;
                });*/

                if (section) {
                    homeManagerSvc.saveLastStore(storeId, langId, section);
                }

                NavigationService.goToHomePage(section, {iStoreId:storeId, iLangId:langId});
                //url = inditex.encodeStoreUrlWithParams(storeFound, langId, true);

                //document.location.href = url;
                return true;
            } else {
                return false;
            }
        }

        function _redirectWithParams() {
            _this.pendingRedirect = false;
            ItxApiSvc.getCategoryTree().then(function () {
            
                switch (_this.typeRedirect) {
                    case 'share':
                        // puede redirigir a la categoria o la worldwide con una cookie en localstorage si no tenemos store para montar la url
                        var url = HomeParseUrl.getShareUrl(_this.iParams);
                        document.location.href = url;
                        break;

                    default:
                        window.location.href =
                            HomeParseUrl.getEncodeUrl(inditex.iStoreJSON) +
                            _this.iParams.redirect[0];
                        break;
                }
            });
        }
    }
})();
